/* eslint-disable camelcase */
/* @flow strict */

import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { GET, PUT } from '/client/src/api';
import { stripeData } from '/client/src/utils/checkStripeData';
import Panel from './../../components/panel';
import EditPaymentModal from './modals/payment';
import PreloadPanelRow from './../../components/panel/preloadPanelRow';
import Switcher from '/client/src/components/switcher';

type PropsType = { 
  isModalOpenByDefault: boolean
};

const SettingsPagePayment = ({ isModalOpenByDefault = false }: PropsType): React.Element<typeof React.Fragment> => {
  const context = React.useContext(DefaultContainerContext);
  const [isOpen, handleToggleModal] = React.useState(false);
  const [payData, setPayData] = React.useState(null);
  const [isStripe3DSecure, setStripe3DSecure] = React.useState(_.get(context, 'profileCurrent.use_payment_3ds', false));
  const [isPending, setPending] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
    handleToggleModal(isModalOpenByDefault);
    }, 500);
  }, [isModalOpenByDefault]);

  const getPayData = React.useCallback(async () => {
    try {
      setPending(true);
      const { result } = await GET('/api/v1/1/merchants/paymentmethod/stripe_token_direct/settings');

      setPayData(result);
      setPending(false);
    } catch (e) {
      setPending(false);
    }
  }, []);

  if (!isPending && !payData) {
    getPayData();
  }

  const {
    connectedAccount,
    connectedCurrency
  } = stripeData(payData, context);

  const handleSetStripe3DSecure = async (checked: boolean) => {
    try {
      await PUT('/api/v1/1/merchants/3dsecure', {
        use_payment_3ds: checked
      });

      setStripe3DSecure(checked);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Panel
        className='SettingsPagePayment-payment'
        title={
          <div>
            Payment Information
            <span
              className='panel-title-action  btn'
              onClick={(): any => handleToggleModal(true)}
            >Edit</span>
          </div>
        }
        headerClassName='panel-heading-green'
      >
        <div className="row">
          <div className="col-lg-6">
            <ul className='table'>
              <li>
                <span className='key'>Currency</span>
                <span className='value'>
                  {connectedCurrency ? connectedCurrency : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Stripe account</span>
                <span className='value'>
                  {payData ? connectedAccount  : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Stripe 3D Secure</span>
                <span className='value'>
                <Switcher
                  className='form-switcher pull-left'
                  checked={isStripe3DSecure}
                  id={1}
                  index={1}
                  onCallback={(): void => handleSetStripe3DSecure(!isStripe3DSecure)}
                />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </Panel>

      {isOpen &&
        <EditPaymentModal
          isOpen={isOpen}
          handleToggleModal={handleToggleModal}
          settings={
            {
              payData: { ...payData },
              // connectedCurrency,
              connectedAccount
            }
          }
        />
      }
    </>
  );
};

export default SettingsPagePayment;
